<script>
  import { Button, Modal, ModalBody, ModalFooter } from '@sveltestrap/sveltestrap';
  import snarkdown from 'snarkdown';

  import { Icon } from '@client/components/icon';

  import howThisWorksRaw from '../../how-this-works.md?raw';

  export let show = false;

  /**
   * Convert markdown tables to HTML tables since snarkdown doesn't support them.
   */
  const parseTables = (md) => {
    return md.replace(/(\|.+\|)\n(\|[-| :]+\|)\n((?:\|.+\|\n?)+)/g, (_, headerRow, _separator, bodyRows) => {
      const headers = headerRow
        .split('|')
        .filter((c) => c.trim())
        .map((c) => `<th>${snarkdown(c.trim())}</th>`)
        .join('');

      const rows = bodyRows
        .trim()
        .split('\n')
        .map((row) => {
          const cells = row
            .split('|')
            .filter((c) => c.trim())
            .map((c) => `<td>${snarkdown(c.trim())}</td>`)
            .join('');
          return `<tr>${cells}</tr>`;
        })
        .join('');

      return `\n\n<table><thead><tr>${headers}</tr></thead><tbody>${rows}</tbody></table>\n\n`;
    });
  };

  const BLOCK_TAGS = /^<(h[1-6]|ol|ul|table|hr|blockquote|pre)/i;

  /**
   * Process the raw markdown: handle tables first, then render each remaining
   * block through snarkdown. Adds support for <hr>, and wraps inline text in <p>.
   */
  const renderMarkdown = (raw) => {
    const withTables = parseTables(raw);

    return withTables
      .split('\n\n')
      .map((block) => {
        const trimmed = block.trim();
        if (!trimmed) return '';
        if (/^-{3,}$/.test(trimmed)) return '<hr>';

        const rendered = snarkdown(trimmed);

        // Wrap in <p> unless it already starts with a block-level element
        if (!BLOCK_TAGS.test(rendered)) {
          return `<p>${rendered}</p>`;
        }

        return rendered;
      })
      .filter(Boolean)
      .join('\n');
  };

  $: html = renderMarkdown(howThisWorksRaw);

  const onKeyDown = (event) => {
    if (event.key === 'Escape') {
      show = false;
    }
  };
</script>

<Modal bind:isOpen={show} size="lg">
  <div class="how-this-works-modal">
    <div class="modal-actions">
      <button class="close" on:click={() => (show = false)}>
        <Icon name="x" />
      </button>
    </div>

    <div class="guide-content">
      {@html html}
    </div>

    <div class="footer-actions">
      <Button color="secondary" on:click={() => (show = false)}>Close</Button>
    </div>
  </div>
</Modal>

<svelte:window on:keydown={onKeyDown} />

<style lang="scss" src="./how-this-works.scss"></style>
